<template>
  <AccountFrame>
    <ForgotPasswordForm v-if="step === 0" v-model:step="step" />
    <SuccessFrame
      v-else
      title="ส่งคำร้องสำเร็จ"
      btn-text="กลับหน้าหลัก"
      :on-click="() => router.push({ name: ROUTE_NAMES.HOME })"
    >
      <p class="text-center">กรุณาตรวจสอบอีเมลของคุณ</p>
    </SuccessFrame>
  </AccountFrame>
</template>

<script setup lang="ts">
import AccountFrame from "@/components/account/AccountFrame.vue";
import { ROUTE_NAMES } from "@/router/constants";
import { defineAsyncComponent, ref } from "vue";
import { useMeta } from "vue-meta";
import { useRouter } from "vue-router";

useMeta({ title: "ลืมรหัสผ่าน" });

const router = useRouter();
const step = ref<number>(0);

const ForgotPasswordForm = defineAsyncComponent(
  () => import("@/components/forms/ForgotPasswordForm.vue"),
);
const SuccessFrame = defineAsyncComponent(
  () => import("@/components/account/SuccessFrame.vue"),
);
</script>
